import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/debt-follow-up`;

const getDebtFollowUps = async (shop, step) => {
  return await axios.post(API_URL, { shop, step });
};

const markDone = async (customerId, step, shop, adminId, orderIds, trackingNumber = null) => {
  return await axios.post(`${API_URL}/done`, { customerId, step, shop, adminId, orderIds, trackingNumber });
};

const markCall = async (customerId, shop, adminId) => {
  return await axios.post(`${API_URL}/mark-call`, { customerId, shop, adminId });
};

const getCallFollowUps = async (shop) => {
  return await axios.post(`${API_URL}/call-list`, { shop });
};

const moveToWaiting = async (callFollowUpId, promisedPayDate) => {
  return await axios.post(`${API_URL}/move-to-waiting`, { callFollowUpId, promisedPayDate });
};

const getWaitingCallFollowUps = async (shop) => {
  return await axios.post(`${API_URL}/waiting-list`, { shop });
};

const postponeCall = async (callFollowUpId, promisedPayDate) => {
  return await axios.post(`${API_URL}/postpone`, { callFollowUpId, promisedPayDate });
};

const getTabCounts = async (shop) => {
  return await axios.post(`${API_URL}/counts`, { shop });
};

const getLetterData = async (customerId, shop) => {
  return await axios.post(`${API_URL}/letter-data`, { customerId, shop });
};

const markPromise = async (customerId, shop, adminId, promisedPayDate, note, currentTab, orderIds) => {
  return await axios.post(`${API_URL}/mark-promise`, {
    customerId, shop, adminId, promisedPayDate, note, currentTab, orderIds,
  });
};

const pushToFinalNotice = async (callFollowUpId, customerId, shop, adminId, targetStep = 2) => {
  return await axios.post(`${API_URL}/push-to-final-notice`, {
    callFollowUpId, customerId, shop, adminId, targetStep,
  });
};

const getBankInfo = async (amount) => {
  return await axios.post(`${API_URL}/bank-info`, { amount });
};

export default {
  getDebtFollowUps,
  markDone,
  markCall,
  markPromise,
  pushToFinalNotice,
  getCallFollowUps,
  moveToWaiting,
  getWaitingCallFollowUps,
  postponeCall,
  getTabCounts,
  getLetterData,
  getBankInfo,
};
